// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "智慧配电网运行与规划",
      "tec": "张皓男",
      "week": "1-8周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "电力系统继电保护",
      "tec": "韩玥",
      "week": "1-11周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "高电压技术",
      "tec": "李昊鸾于力",
      "week": "1-8周",
      "add": "教学楼A座222电力"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "高电压技术",
      "tec": "李昊鸾于力",
      "week": "1-8周",
      "add": "教学楼C座210教务"
    },
    {
      "sub": "电气设备及主系统",
      "tec": "胡田",
      "week": "1-12周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "人工智能概论",
      "tec": "田卫华",
      "week": "8-15周",
      "add": "教学楼A座322电力"
    },
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "电力系统继电保护",
      "tec": "韩玥",
      "week": "1-11周",
      "add": "教学楼A座118电力"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电气设备及主系统",
      "tec": "胡田",
      "week": "1-12周",
      "add": "教学楼A座326电力"
    },
    0,
    {
      "sub": "能源经济基础",
      "tec": "刘钰彤",
      "week": "8-15周",
      "add": "教学楼A座221电力"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "分布式发电与微电网",
      "tec": "金红洋",
      "week": "1-8周",
      "add": "教学楼A座222电力"
    },
    {
      "sub": "电力系统继电保护",
      "tec": "韩玥",
      "week": "1,3,5,7,9,11周",
      "add": "教学楼A座226电力"
    },
    {
      "sub": "高电压技术",
      "tec": "李昊鸾于力",
      "week": "1-8周",
      "add": "教学楼A座222电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
